export default "__VITE_ASSET__DSGbhLmz__"